import LeaderboardDetailModule from '@/modules/leaderboard/leaderboard-detail';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  edit: z.string().optional(),
});

const paramsSchema = z.object({
  id: z.coerce.string(),
});

export const Route = createFileRoute('/dashboard/leaderboard/$id')({
  params: {
    parse: params => paramsSchema.parse(params),
    stringify: params => ({ id: String(params.id) }),
  },
  validateSearch: searchSchema,
  component: LeaderboardDetailPage,
});

function LeaderboardDetailPage() {
  return <LeaderboardDetailModule />;
}
